<template>
    <div class="h-full">
        <div class="flex items-center gap-2 px-6 py-4">
            <AppLogo :appName="appName" />
        </div>
        <nav class="">
            <ul class="space-y-0.5 text-sm px-2 p-4">
                <SidebarItem
                    iconName="home"
                    :href="RoutePathAppEnum.Root"
                    :active="currentRoute == RoutePathAppEnum.Root"
                >
                    Dashboard
                </SidebarItem>
                <SidebarItem
                    iconName="users"
                    :href="RoutePathAppEnum.Admin_Users"
                    :active="
                        currentRoute.startsWith(RoutePathAppEnum.Admin_Users)
                    "
                >
                    Users
                </SidebarItem>
                <SidebarItem
                    iconName="bolt"
                    :href="RoutePathAppEnum.Admin_Queue_Pending"
                    :active="
                        currentRoute.startsWith(
                            RoutePathAppEnum.Admin_Queue_Pending,
                        )
                    "
                >
                    Queue Pending
                </SidebarItem>
                <SidebarItem
                    iconName="bolt"
                    :href="RoutePathAppEnum.Admin_Queue_Processed"
                    :active="
                        currentRoute.startsWith(
                            RoutePathAppEnum.Admin_Queue_Processed,
                        )
                    "
                >
                    Queue Processed
                </SidebarItem>
            </ul>
        </nav>
    </div>
</template>

<script setup lang="ts">
    import SidebarItem from '@/Shared/Layout/Admin/SidebarItem.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface AdminSidebarProps {
        appName: string
        currentRoute: string
    }

    const props = defineProps<AdminSidebarProps>()
</script>
